// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TwoColumnsTextRight {
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
}

.TwoColumnsTextRight-title {
  padding-top: 100px;
  padding-bottom: 60px;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
    align-items: baseline;
    padding-bottom: 18px;
  }
}

.TwoColumnsTextRight-content {
  display: flex;
  flex-direction: row;
  gap: 32px;
  @media screen and (max-width: 1024px) {
    gap: 16px;
  }
}

.TwoColumnsTextRight-box {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  border-radius: 32px;
  padding: 40px;
  box-sizing: border-box;
  @media screen and (max-width: 1024px) {
    border-radius: 16px;
    padding: 20px;
  }
}

.TwoColumnsTextRight-media {
  justify-content: center;
  align-items: center;
}

.TwoColumnsTextRight-text {
  justify-content: space-between;
  background: #fff;
}

.TwoColumnsTextRight-image {
  background-size: cover;
  background-position: center;
  width: 100%;
  height: auto;
  min-height: 248px;
  aspect-ratio: 1 / 1;
}

.TwoColumnsTextRight-box.TwoColumnsTextRight-text > a {
  margin-top: 50px;
  max-width: max-content;
  @media screen and (max-width: 1024px) {
    text-wrap: auto;
  }
}

@media screen and (max-width: 1024px) {
  .TwoColumnsTextRight-content {
    flex-direction: column;
  }

  .TwoColumnsTextRight .b2-body-400 h1 {
    font-size: 36px;
  }
}

.TwoColumnsTextRight .b2-body-400 h1 {
  font-size: 52px;
}

.TwoColumnsTextRight-content .b2-body-400 h1,
.TwoColumnsTextRight-content .b2-body-400 h2 {
  margin-top: 0;
}

.TwoColumnsTextRight-content .b2-body-400 h3,
.TwoColumnsTextRight-content .b2-body-400 h4,
.TwoColumnsTextRight-content .b2-body-400 h5,
.TwoColumnsTextRight-content .b2-body-400 h6 {
  margin: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/css/TwoColumnsTextRight.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;EAC9B,mBAAmB;;EAEnB;IACE,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,SAAS;EACX;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB;IACE,mBAAmB;IACnB,aAAa;EACf;AACF;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,oBAAoB;AACtB","sourcesContent":[".TwoColumnsTextRight {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 30px;\n}\n\n.TwoColumnsTextRight-title {\n  padding-top: 100px;\n  padding-bottom: 60px;\n  justify-content: space-between;\n  align-items: center;\n\n  @media screen and (max-width: 1024px) {\n    flex-direction: column;\n    align-items: baseline;\n    padding-bottom: 18px;\n  }\n}\n\n.TwoColumnsTextRight-content {\n  display: flex;\n  flex-direction: row;\n  gap: 32px;\n  @media screen and (max-width: 1024px) {\n    gap: 16px;\n  }\n}\n\n.TwoColumnsTextRight-box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  border-radius: 32px;\n  padding: 40px;\n  box-sizing: border-box;\n  @media screen and (max-width: 1024px) {\n    border-radius: 16px;\n    padding: 20px;\n  }\n}\n\n.TwoColumnsTextRight-media {\n  justify-content: center;\n  align-items: center;\n}\n\n.TwoColumnsTextRight-text {\n  justify-content: space-between;\n  background: #fff;\n}\n\n.TwoColumnsTextRight-image {\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n  height: auto;\n  min-height: 248px;\n  aspect-ratio: 1 / 1;\n}\n\n.TwoColumnsTextRight-box.TwoColumnsTextRight-text > a {\n  margin-top: 50px;\n  max-width: max-content;\n  @media screen and (max-width: 1024px) {\n    text-wrap: auto;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .TwoColumnsTextRight-content {\n    flex-direction: column;\n  }\n\n  .TwoColumnsTextRight .b2-body-400 h1 {\n    font-size: 36px;\n  }\n}\n\n.TwoColumnsTextRight .b2-body-400 h1 {\n  font-size: 52px;\n}\n\n.TwoColumnsTextRight-content .b2-body-400 h1,\n.TwoColumnsTextRight-content .b2-body-400 h2 {\n  margin-top: 0;\n}\n\n.TwoColumnsTextRight-content .b2-body-400 h3,\n.TwoColumnsTextRight-content .b2-body-400 h4,\n.TwoColumnsTextRight-content .b2-body-400 h5,\n.TwoColumnsTextRight-content .b2-body-400 h6 {\n  margin: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
